export default __webpack_public_path__ + "static/Image013-9e390af4f33941644b490b66e9fb425e.png";